var Accordion = {
	init:function(){
		let _els = document.getElementsByClassName('js-trigger-accordion');
		for (var _i=0;_i<_els.length;_i++) {
			if (_els[_i].classList.contains('state-accordion-setup') === false) {
				_els[_i].addEventListener('click', function(_evt){
					_evt.preventDefault();
					var _parent = _evt.currentTarget.closest('.js-accordion-parent');
					if (_parent.classList.contains('state-item-open')) {
						_parent.classList.remove('state-item-open')
					} else {
						_parent.classList.add('state-item-open')
					}
					Accordion.resize();
				});
			}
		}
		window.addEventListener('resize', function(){
			Accordion.resize();
		});
	},
	resize:function(){
		let _els = document.getElementsByClassName('js-accordion-parent');
		for (var _i=0;_i<_els.length;_i++) {
			var _body = _els[_i].getElementsByClassName('js-accordion-body')[0];
			var _inner = _els[_i].getElementsByClassName('js-accordion-body-inner')[0];
			if (_els[_i].classList.contains('state-item-open')) {
				_body.style.maxHeight = _inner.clientHeight + 'px';
			} else {
				_body.style.maxHeight = '0px';
			}
		}
	}
}
Accordion.init();